import React from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import MultipleBets from './MultipleBets';
import PotentialWinBox from './PotentialWinBox';
import SingleBets from './SingleBets';
import SystemBets from './SystemBets';

export default function Coupon(props) {
    const betslipContext = React.useContext(BetslipContext);

    const couponKey = props.couponKey;
    let betslipData = betslipContext.getBetslipData();
    const coupon = betslipData.coupons[couponKey];
    const tabAttivo = coupon.selectedContainer === 'betbuilder'? 'multibets' : coupon.selectedContainer;
    
    return (
        <>
            <div className="cart__body">
                <div className="cartEvents__container">
                    {function() {
                        switch (tabAttivo) {
                            default:
                            case 'singlebets':
                                return <SingleBets couponKey={props.couponKey} />
                            case 'multibets':
                                return <MultipleBets couponKey={props.couponKey} />
                            case 'systembets':
                                return <SystemBets couponKey={props.couponKey} />
                        }
                    }()}
                </div>
            </div>
            <div className="cart__footer">
                <PotentialWinBox container={tabAttivo} couponKey={couponKey} />
            </div>
        </>
    );
}
